// src/views/balances/actions/ContractActionsView.js
import React from 'react';
import { Container, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Page from 'src/components/Page';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import { selectContractActionsQueryOptions } from 'src/store/selectors/contractActionsSelectors';
import formatMonthYear from 'src/utils/formatMonthYear';
import ContractActionsToolbar from './components/ContractActionsToolbar';
import ContractActionsKpiCards from './components/ContractActionsKpiCards';
import ContractActionsSegments from './components/ContractActionsSegments';
import { ContractActionsList } from './components/ContractActionsList';

const useStyles = makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ContractActionsPage = () => {
  const { classes } = useStyles();
  const { t, i18n } = useTranslation();
  const { month, year } = useSelector(selectContractActionsQueryOptions);
  const activeDate = month && year ? new Date(year, month - 1, 1) : new Date();
  const monthLabel = formatMonthYear(activeDate, i18n.language);
  const pageTitle = t('CONTRACT_ACTIONS.PAGE_TITLE', { month: monthLabel });

  return (
    <Page className={classes.root} title={pageTitle}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <ContractActionsToolbar title={pageTitle} />
          <Box mt={3}>
            <ContractActionsKpiCards />
          </Box>
          <Box mt={3}>
            <ContractActionsSegments />
          </Box>
          <Box mt={1}>
            <ContractActionsList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

const ContractActionsView = () => (
  <RolePrivateRoute component={ContractActionsPage} />
);

export default ContractActionsView;
